import { validateStaticEnvVars } from "./env-config.schema";

/** @deprecated use publicConfig from useServices hook instead */
export const browserEnvConfig = validateStaticEnvVars({
  NEXT_PUBLIC_APP_URL: process.env.NEXT_PUBLIC_APP_URL,
  NEXT_PUBLIC_API_BASE_URL: process.env.NEXT_PUBLIC_API_BASE_URL,
  NEXT_PUBLIC_API_BASE_URL_SANDBOX: process.env.NEXT_PUBLIC_API_BASE_URL_SANDBOX,
  NEXT_PUBLIC_API_BASE_URL_TESTNET: process.env.NEXT_PUBLIC_API_BASE_URL_TESTNET,
  NEXT_PUBLIC_STATS_APP_URL: process.env.NEXT_PUBLIC_STATS_APP_URL,
  NEXT_PUBLIC_PROVIDER_PROXY_URL: process.env.NEXT_PUBLIC_PROVIDER_PROXY_URL,
  NEXT_PUBLIC_DEFAULT_NETWORK_ID: process.env.NEXT_PUBLIC_DEFAULT_NETWORK_ID,
  NEXT_PUBLIC_DEFAULT_INITIAL_DEPOSIT: process.env.NEXT_PUBLIC_DEFAULT_INITIAL_DEPOSIT,
  NEXT_PUBLIC_NODE_ENV: process.env.NEXT_PUBLIC_NODE_ENV,
  NEXT_PUBLIC_BASE_API_MAINNET_URL: process.env.NEXT_PUBLIC_BASE_API_MAINNET_URL,
  NEXT_PUBLIC_BASE_API_TESTNET_URL: process.env.NEXT_PUBLIC_BASE_API_TESTNET_URL,
  NEXT_PUBLIC_BASE_API_SANDBOX_URL: process.env.NEXT_PUBLIC_BASE_API_SANDBOX_URL,
  NEXT_PUBLIC_BASE_TEMPLATES_URL: process.env.NEXT_PUBLIC_BASE_TEMPLATES_URL
});

export type BrowserEnvConfig = typeof browserEnvConfig;
